import { Box, Typography } from '@mui/material'
import React from 'react'

export const Footer = () => {
    return (
        <footer>
            <Box height={40} color='white' bgcolor='primary.main' display='flex' alignItems='center' padding='0px 15px'>
                <Typography color='white' fontSize={12}>Faraday @ 2022</Typography>
            </Box>
        </footer>
    )
}
